<template>
<m-pageframe
    :title="title"
    :color="pageframe_color"
>
<v-container
    style="padding-left: 25px; padding-right: 25px;"
    fluid
>
<v-expansion-panels
    v-if="profile != null"
    v-model="open_panel"
    
>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">General Settings</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-account-general
                :profile="profile"
                v-on:patch-employee-account="onPatchEmployeeAccount"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Security and Password</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-account-password
                :profile="profile"
                v-on:change-password="onSetPassword"
                v-on:reload-profile="reloadProfile"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Contact Information</v-expansion-panel-header>
        <v-expansion-panel-content>
           <m-settings-account-contact
            :profile="profile"
            v-on:upsert-contact="onUpsertContact"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Personal Notification Devices</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-account-personal-devices
                :profile="profile"
                v-on:patch-employee-account="onPatchEmployeeAccount"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">RedChirp Phone Numbers</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-account-organization-endpoints
                :profile="profile"
                v-on:patch-endpoint="onPatchEndpoint"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Available Hours</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-account-available-hours
                :profile="profile"
                v-on:patch-employee-account="onPatchEmployeeAccount"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>


    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Notifications and Sounds</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-account-notifications
                :profile="profile"
                v-on:patch-employee-account="onPatchEmployeeAccount"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Phone Calls and Voicemail</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-account-phone-calls
                :profile="profile"
                v-on:patch-employee-account="onPatchEmployeeAccount"
                v-on:reload-profile="reloadProfile"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

     <v-expansion-panel
        v-if="profile.employee_account.is_system_admin"
     >
        <v-expansion-panel-header class="bold_header">Integrations</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                v-on:click="onClickIntegrations"
                color="primary"
            >
                Integrations...
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>


    

</v-expansion-panels>
</v-container>



</m-pageframe>
</template>

<script>

const E164 = require("@/js/E164.js");
var _ = require('lodash');

export default {
    data() {
        return {
            profile: null,
            open_panel: null,
        }
    },

    mounted () {

        this.open_panel = this.$rc.getOpenPanel(this.$route);
        this.reloadProfile();
    },

    beforeRouteUpdate (to, from, next) 
    {
        next();

        this.reloadProfile();
    },

    methods: {

        reloadProfile()
        {
            this.$rc.showSpinner();

            let employee_id = this.$route.params.employee_id;

            let on_error = () => {
                alert("Unable to load employee profile");
                this.$router.push({'name': 'home'}).catch(e=>{}); // swallow any exception
            };

            this.$rc.getEmployeeProfile(employee_id, this.onReceiveProfile, on_error);
        },

        onReceiveProfile(profile) 
        {
            this.profile = profile;
            this.$rc.hideSpinner();

            this.$forceUpdate();
        },

        onPatchEmployeeAccount(changes)
        {
            changes.employee_id = this.profile.employee_account.employee_id;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PATCH: /api/v1/employees',
            
                'params' : changes,
            
                'on_success': (data) => {
                        this.reloadProfile();
                    },
            
                'on_error': 'Unable to update employee account',
            });
        },

        onPatchEndpoint(changes)
        {
            this.$rc.showSpinner();
            this.$rc.patchOrganizationEndpoint(changes.endpoint, changes, () => this.reloadProfile() );
        },

        onUpsertContact(new_contact)
        {
            this.$rc.showSpinner();
            this.$forceUpdate();
            this.$rc.upsertContact(new_contact, () => this.reloadProfile());
        },

        onSetPassword(password_data)
        {
            let on_success = () => {
                alert('Password changed');

                // Changed my own password...
                if ( this.profile.employee_account.employee_id === this.$rc.$state.employee_id )
                {
                    this.$router.push({'name': 'sign-in'}).catch(e=>{}); // swallow any exception
                }
            };

            this.$rc.setPassword(password_data, on_success, (message) => alert(message));
        },

        onClickIntegrations()
        {
            this.$router.push({
                'name': 'settings-account-search-oauth-integrations',
                'params' : {
                    'employee_id': this.$route.params.employee_id
                }
            });
        },
    },

    computed: {
        pageframe_color() {
            if ( this.$route.params.employee_id != this.$rc.$state.employee_id )
                return '#5D647C';
            
            return '#F24653';
        },

        title() {
            if ( this.profile == null ) return 'Account Settings';
            
            return this.profile.employee_account.username;
        },
    },
}
</script>

<style lang="scss" scoped>
.bold_header
{
    font-size: 20px; 
    font-weight: bold;
}
</style>